import React, { useState } from 'react'
import SidebarMobile from '../navigation/SidebarMobile'
import SidebarDesktop from '../navigation/SidebarDesktop'
import SidebarOpenButton from '../navigation/SidebarOpenButton'
import { Transition } from '@tailwindui/react'

export default function WithSidebarAndHeader (props) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className='h-screen flex overflow-hidden bg-background'>
      {/* Off-canvas menu for mobile */}
      <SidebarMobile isOpen={isOpen} setIsOpen={setIsOpen} logo={props.logo}>
        {props.sidebar}
      </SidebarMobile>

      {/* Static sidebar for desktop */}
      <SidebarDesktop logo={props.logo}>
        {props.sidebar}
      </SidebarDesktop>

      <div className='flex flex-col w-0 flex-1 overflow-hidden'>
        <main className='flex-1 relative z-0 overflow-y-auto focus:outline-none' tabIndex='0'>
          {/* Button to open the sidebar */}
          <SidebarOpenButton onClick={() => setIsOpen(!isOpen)} />

          {/* Main Content */}
          {props.children}
        </main>
      </div>
    </div>
  )
}
